import { useHomeSecurity } from '@contexts/HomeSecurityContext/HomeSecurityContext';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useWorksitePresentationPageVM = () => {
    const [steps, setSteps] = useState<
        { label: string; status: string; isFilled: boolean; checkboxes: { label: string; isChecked: boolean }[] }[]
    >([
        {
            label: 'Présentation du chantier',
            status: 'inProgress',
            checkboxes: [
                {
                    label: 'Visites des installations communes du chantier (vestiaire, réfectoire, sanitaires)',
                    isChecked: false
                },
                {
                    label: 'Accès et circulation piéton/engins de chantier',
                    isChecked: false
                },
                {
                    label: 'Lieu de stationnement véhicule',
                    isChecked: false
                },
                {
                    label: 'Zone de stockage matériel',
                    isChecked: false
                },
                {
                    label: 'Emplacement des bennes à déchets',
                    isChecked: false
                },
                {
                    label: 'Risques liés à la coactivité (vigilance partagée)',
                    isChecked: false
                },
                {
                    label: 'Consignes particulières du chantier',
                    isChecked: false
                }
            ],
            isFilled: false
        }
    ]);

    const navigate = useNavigate();
    const { handleAddPassedModule, setWorksitePresentation, worksitePresentationComment, setWorksitePresentationComment, worksiteId } =
        useHomeSecurity();

    useEffect(() => {
        if (!worksiteId) {
            navigate('/sante-securite/home-security');
        }
    }, [worksiteId, navigate]);

    const handleNext = () => {
        navigate('/sante-securite/home-security/menu');
        handleAddPassedModule('worksite-presentation');
    };

    const handleSetCheckbox = (index: number, checkboxIndex: number, isChecked: boolean) => {
        const newSteps = [...steps];
        newSteps[index].checkboxes[checkboxIndex].isChecked = isChecked;
        newSteps[index].isFilled = newSteps[index].checkboxes
            .filter((checkbox) => checkbox.label !== 'Consignes particulières du chantier')
            .every((checkbox) => checkbox.isChecked);
        setSteps(newSteps);
    };

    const isConsignesParticulieresChecked = useMemo(
        () =>
            steps[0].checkboxes
                .filter((checkbox) => checkbox.label === 'Consignes particulières du chantier')
                .every((checkbox) => checkbox.isChecked),
        [steps]
    );

    useEffect(() => {
        const worksitePresentations = steps[0].checkboxes.filter((checkbox) => checkbox.isChecked).map((checkbox) => checkbox.label);
        setWorksitePresentation(worksitePresentations);
    }, [steps, setWorksitePresentation]);

    return {
        steps,
        handleNext,
        handleSetCheckbox,
        isConsignesParticulieresChecked,
        worksitePresentationComment,
        setWorksitePresentationComment
    };
};
